import * as React from 'react';
import PropTypes from 'prop-types';
import { StyledChip, StyledChipSpan } from './Chip.style';

/**
 * Use a Chip to represent a certain attribute of an object.
 *
 * Because the Chip component is used also to display the colors of the statuses and profiles of an event defined by the Yesplan installation the background, border and text color can be set by the props bgColor, borderColor and textColor. These props expect a hex color string and are not limited to the color variations of the App color library.
 */

const Chip = ({
  children,
  variant = 'default',
  bgColor = '',
  borderColor = '',
  textColor = '',
  className = '',
  dataAttributes = {}
}) => {
  return (
    <StyledChip
      $variant={variant}
      $bgColor={bgColor}
      $borderColor={borderColor}
      className={className}
      {...dataAttributes}
    >
      <StyledChipSpan $variant={variant} $textColor={textColor}>
        {children}
      </StyledChipSpan>
    </StyledChip>
  );
};

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  /** ClassName is supported such that styled components can pass extra styling.
   * Do not use this to adjust the styling, because the ordering of the applied tailwind classes is undeterministic */
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'counter']),
  dataAttributes: PropTypes.shape({}),
  /** Background color value; overwrites default 'bg-silver-base' */
  bgColor: PropTypes.string,
  /** Border color value; if this value is set we also add the tw 'border' prop */
  borderColor: PropTypes.string,
  /** Text color value; gets inherited by direct span & p elements and overwrites default 'text-black' */
  textColor: PropTypes.string
};

export default Chip;
